import React from 'react';
import { Shield, Server, Lock, Cpu, UserCheck, Check } from 'lucide-react';

// Category icons mapping
const CATEGORY_ICONS = {
  Security: Shield,
  Availability: Server,
  Confidentiality: Lock,
  'Processing Integrity': Cpu,
  Privacy: UserCheck,
};

const TSCCategorySelector = ({
  categories, // Array of { id, label, required, description }
  selectedCategories, // Array of selected category IDs
  onToggle, // Function to toggle category selection
  disabled = false,
}) => {
  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Trust Service Categories
      </label>
      <p className="text-sm text-gray-500 mb-4">
        Select the categories to include in your compliance scope. Security is always required.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {categories.map((category) => {
          const isSelected = selectedCategories.includes(category.id);
          const Icon = CATEGORY_ICONS[category.id] || Shield;
          const isDisabled = disabled || category.required;

          return (
            <button
              key={category.id}
              type="button"
              onClick={() => !isDisabled && onToggle(category.id)}
              disabled={isDisabled}
              className={`
                relative p-4 rounded-lg border-2 transition-all text-left
                ${isSelected
                  ? 'border-teal-600 bg-teal-50'
                  : 'border-gray-200 bg-white hover:border-gray-300'
                }
                ${isDisabled && !category.required ? 'opacity-50 cursor-not-allowed' : ''}
                ${category.required ? 'cursor-default' : 'cursor-pointer'}
              `}
            >
              {/* Selected Checkmark */}
              {isSelected && (
                <div className="absolute top-2 right-2">
                  <div className="w-5 h-5 rounded-full bg-teal-600 flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                </div>
              )}

              <div className="flex items-start gap-3">
                <div
                  className={`
                    w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0
                    ${isSelected ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-600'}
                  `}
                >
                  <Icon className="w-5 h-5" />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span
                      className={`
                        text-sm font-medium
                        ${isSelected ? 'text-teal-900' : 'text-gray-900'}
                      `}
                    >
                      {category.label}
                    </span>
                    {category.required && (
                      <span className="text-xs bg-gray-200 text-gray-600 px-2 py-0.5 rounded">
                        Required
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-gray-500 mt-1 line-clamp-2">
                    {category.description}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TSCCategorySelector;
